import { render, staticRenderFns } from "./volume-edit.vue?vue&type=template&id=d0556fb8&scoped=true&"
import script from "./volume-edit.vue?vue&type=script&lang=js&"
export * from "./volume-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0556fb8",
  null
  
)

export default component.exports